
    import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator';
    import { namespace } from 'nuxt-property-decorator';
    import { IGroup } from '@/store/page';

    const pages = namespace('pages');

    @Component
    export default class OptionsFieldsGroup extends Vue {
        @Prop() value;
        @pages.State groups: IGroup[];

        @Emit('input')
        onChange(val) {
            return {
                ...this.value,
                id: val,
                _id: val
            };
        }

        get groupsSelect() {
            if (this.groups) {
                const groupsForSelect: object[] = [];

                groupsForSelect.push({ text: 'Нет группы', value: null });

                this.groups.map(group => {
                    groupsForSelect.push({
                        text: group.options.name,
                        value: group._id
                    });
                });

                return groupsForSelect;
            } else {
                return [];
            }
        }
    }
